/* eslint-disable react/prop-types */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash } from '@fortawesome/free-solid-svg-icons';
import { categoryLabel } from './helpers';

const PatientFileCard = ({
    doc,
    previewLoadingId,
    deletingId,
    onPreview,
    onDelete,
    canDelete = true,
}) => {
    const loading = previewLoadingId === doc._id;
    const deleting = deletingId === doc._id;

    return (
        <div
            className="patient-files__card"
            role="button"
            tabIndex={0}
            onClick={() => !deleting && onPreview(doc._id)}
            onKeyDown={(ev) => {
                if (ev.key === 'Enter' || ev.key === ' ') {
                    ev.preventDefault();
                    if (!deleting) onPreview(doc._id);
                }
            }}
        >
            <div className="patient-files__card-main">
                <p className="patient-files__card-title">
                    {doc.title?.trim() || doc.finalFileName || 'Document'}
                </p>
                {doc.description?.trim() ? (
                    <p className="patient-files__card-desc">{doc.description.trim()}</p>
                ) : null}
                <div className="patient-files__card-meta">
                    <span className="patient-files__pill">{categoryLabel(doc.category)}</span>
                    {doc.clinicalType ? (
                        <span className="patient-files__pill patient-files__pill--muted">
                            {doc.clinicalType.replace(/_/g, ' ')}
                        </span>
                    ) : null}
                </div>
            </div>
            <div className="patient-files__card-actions">
                <button
                    type="button"
                    className="patient-files__icon-btn patient-files__icon-btn--view"
                    aria-label="View file"
                    onClick={(ev) => {
                        ev.stopPropagation();
                        onPreview(doc._id);
                    }}
                    disabled={loading || deleting}
                >
                    {loading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                    ) : (
                        <>
                            <FontAwesomeIcon icon={faEye} size="sm" className="me-1" />
                            View
                        </>
                    )}
                </button>
                {canDelete && (
                    <button
                        type="button"
                        className="patient-files__icon-btn patient-files__icon-btn--delete"
                        aria-label="Delete file"
                        onClick={(ev) => {
                            ev.stopPropagation();
                            onDelete(doc._id, ev);
                        }}
                        disabled={deleting || loading}
                    >
                        {deleting ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        ) : (
                            <FontAwesomeIcon icon={faTrash} size="sm" />
                        )}
                    </button>
                )}
            </div>
        </div>
    );
};

export default PatientFileCard;
